const NUTRIENT_BLUE_SHADES = ["#C6E6FF", "#82CFFF", "#31B4F2", "#0092E4"];
const UNASSIGNED_COLOR = "#DFE2E7";

export const createNutrientPlotColorScale = (
  rates: Array<number | null | undefined>
): ((rate: number | null | undefined) => string) => {
  const assignedRates = rates.filter(
    (rate): rate is number =>
      typeof rate === "number" && Number.isFinite(rate) && rate >= 0
  );
  const minRate = assignedRates.length > 0 ? Math.min(...assignedRates) : 0;
  const maxRate = assignedRates.length > 0 ? Math.max(...assignedRates) : 0;

  return (rate) => {
    if (rate == null || !Number.isFinite(rate) || rate < 0) {
      return UNASSIGNED_COLOR;
    }
    if (minRate === maxRate) {
      return NUTRIENT_BLUE_SHADES[rate === 0 ? 0 : 2];
    }

    const position =
      Math.max(0, Math.min(1, (rate - minRate) / (maxRate - minRate))) *
      (NUTRIENT_BLUE_SHADES.length - 1);
    const lowerIndex = Math.floor(position);
    const upperIndex = Math.min(
      lowerIndex + 1,
      NUTRIENT_BLUE_SHADES.length - 1
    );
    const fraction = position - lowerIndex;
    const lowerColor = Number.parseInt(
      NUTRIENT_BLUE_SHADES[lowerIndex].slice(1),
      16
    );
    const upperColor = Number.parseInt(
      NUTRIENT_BLUE_SHADES[upperIndex].slice(1),
      16
    );
    const channels = [16, 8, 0].map((shift) => {
      const lowerChannel = (lowerColor >> shift) & 255;
      const upperChannel = (upperColor >> shift) & 255;
      return Math.round(lowerChannel + (upperChannel - lowerChannel) * fraction)
        .toString(16)
        .padStart(2, "0");
    });
    return `#${channels.join("")}`;
  };
};
